import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layer-badge" }
const _hoisted_2 = { class: "icon-circle" }
const _hoisted_3 = { class: "layer-info" }
const _hoisted_4 = { class: "layer-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['layer-step-card', _ctx.variant]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.badge), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(['mdi', _ctx.icon])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.layerNumber), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.description), 1)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "explore-link" }, [
      _createTextVNode("Explorer "),
      _createElementVNode("span", { class: "mdi mdi-arrow-right" })
    ], -1))
  ], 2))
}